export default __webpack_public_path__ + "static/media/epl-banner-cn.d39d5f8d.webp";